// extracted by mini-css-extract-plugin
export default {"root":"MGttBRIJF9","html":"SqxLO9Q_bz"};